import './Contact.css'
import contact from './shows2.jpg'
import fml from './full_moon_logo.jpeg'

export default function Contact() {
    return (
        <main className='contact-page'>
            <img src={contact} alt="Contact" />
            <div>
                <p>Lithium & Candy offers up to 4 hours of cover songs that promote high energy, dancing, and food/drink sales. Whether it's an intimate acoustic venue, full club performance, or party in your backyard, we've got the entertainment covered. Full sound system and lights can also be provided by request.</p>
                <h2>
                        Booking inquiries:<br />
                    <div className='booking-email'>
                        <a href="mailto:tom@fullmoonentertainmentservices.com">
                            tom@fullmoonentertainmentservices.com
                        </a>
                    </div>
                    <img className='fml' src={fml} alt="Full Moon Logo" />
                </h2>
            </div>
            <div className='socials'>
                <h3>Follow us on socials!</h3>
                <h3><a href="https://www.facebook.com/lithiumandcandy">Facebook</a> | <a href="https://www.instagram.com/lithiumandcandy">Instagram</a></h3>
                {/* <h3>Spotify | <a href="https://open.spotify.com/artist/7mUpGvImwfXocungr7DLxf?si=urFq89F2SIugLFRMg7ZAMg">Downhill Uprise</a></h3> */}
            </div>
        </main>

    )
}